import { Env } from "@/env";
import { SafeAwait } from "@/core/util/SafeAwait";

export class BusinessBookerEvent {
  static $instance = null;
  getCurrentAuthUserFn = null;

  /**
   *
   * @param getCurrentAuthUserFn
   * @param getBookingChannelIdFn
   * @param businessBookerEventManager
   */
  constructor({ getCurrentAuthUserFn, getBookingChannelIdFn, businessBookerEventManager }) {
    if (BusinessBookerEvent.$instance) {
      throw new Error('Use PaxDashboardEvent.register()');
    }

    this.getBookingChannelIdFn = getBookingChannelIdFn;
    this.getCurrentAuthUserFn = getCurrentAuthUserFn;
    this.businessBookerEventManager = businessBookerEventManager;
    BusinessBookerEvent.$instance = this;
  }

  static register({ getCurrentAuthUserFn, getBookingChannelIdFn, businessBookerEventManager }) {
    if (BusinessBookerEvent.$instance) {
      return BusinessBookerEvent.$instance;
    }
    return new BusinessBookerEvent({ getCurrentAuthUserFn, getBookingChannelIdFn, businessBookerEventManager });
  }

  /**
   *
   * @param code
   * @param payload
   * @param pageUri
   * @return {Promise<void>}
   */
  static async send({ code, payload, pageUri }) {
    const { error } = await SafeAwait.execute(async() => {
      const currentUser = BusinessBookerEvent.$instance.getCurrentAuthUserFn();

      if (!currentUser) {
        console.warn('[BusinessBookerEvent] - No current user to send event');
        return;
      }

      const bookingChannelId = BusinessBookerEvent.$instance.getBookingChannelIdFn();
      if (!bookingChannelId) {
        console.warn('[BusinessBookerEvent] - No current booking channel to send event');
        return;
      }

      /**
       *
       * @type {BusinessBookerEventCreateDto}
       */
      const eventPayload = {
        userId: currentUser.id,
        userEmail: currentUser.email,
        bookingChannelId: bookingChannelId,
        code,
        pageUri,
        payload,
        appVersion: Env.getAppVersion(),
        userAgent: navigator.userAgent,
        metadata: {
          locale: navigator.language,
          deviceTime: new Date().toString(),
          userRoles: currentUser.roles,
        },
      };
      console.log('Sending event', eventPayload);
      await BusinessBookerEvent.$instance.businessBookerEventManager.addEvent(eventPayload);
    });

    if (error) {
      console.error(error);
    }
  }
}
